import React from 'react';
import { Button, SvgIconProps, Tooltip } from '@mui/material';

interface ToggleButtonProps<B1 extends string, B2 extends string> {
  button1Label: React.ReactElement<SvgIconProps>;
  button1LabelTxt: B1;
  button2Label: React.ReactElement<SvgIconProps>;
  button2labelTxt: B2;
  onSelect: (selectedButton: B1 | B2) => void;
  selectedLabel: B1 | B2;
  tooltip1?: string;
  tooltip2?: string;
  disableBtn1?: boolean;
  disableBtn2?: boolean;
}

const ToggleButton = <B1 extends string, B2 extends string>({
  button1Label,
  button2Label,
  onSelect,
  button1LabelTxt,
  button2labelTxt,
  selectedLabel,
  tooltip1,
  tooltip2,
  disableBtn1,
  disableBtn2,
}: ToggleButtonProps<B1, B2>) => {
  const handleSelect = (button: B1 | B2) => {
    onSelect(button);
  };

  return (
    <div style={{ display: 'flex', width: '50%' }}>
      <Tooltip title={selectedLabel === button1LabelTxt ? '' : `${tooltip1 ? tooltip1 : ''}`}
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        <Button
          disabled={disableBtn1}
          size="small"
          onClick={() => handleSelect(button1LabelTxt)}
          sx={{
            minWidth: 'unset',
            backgroundColor: selectedLabel === button1LabelTxt ? 'rgb(224, 224, 224)' : 'white',
            color: 'black',
            borderRadius: '5px',
            border: '1px solid lightgray',
            borderRight: 'none',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            cursor: selectedLabel === button1LabelTxt ? 'default' : 'pointer',
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            '&:hover': {
              backgroundColor: selectedLabel === button1LabelTxt ? 'rgb(224, 224, 224)' : 'white',
            },
          }}
        >
          {button1Label}
        </Button>
      </Tooltip>

      <Tooltip title={selectedLabel === button2labelTxt ? '' : `${tooltip2 ? tooltip2 : ''}`}
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        <Button
          disabled={disableBtn2}
          size="small"
          onClick={() => handleSelect(button2labelTxt)}
          sx={{
            minWidth: 'unset',
            backgroundColor: selectedLabel === button2labelTxt ? 'rgb(224, 224, 224)' : 'white',
            color: 'black',
            borderRadius: '5px',
            border: '1px solid lightgray',
            borderLeft: 'none',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            cursor: selectedLabel === button2labelTxt ? 'default' : 'pointer',
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: selectedLabel === button2labelTxt ? 'rgb(224, 224, 224)' : 'white',
            },
          }}
        >
          {button2Label}
        </Button>
      </Tooltip>
    </div>
  );
};

export default ToggleButton;
